<template>
  <svg
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    stroke="none"
    aria-hidden="true"
  >
    <path d="M51.1 36.03h4.5v24.7H0V4.5h24.06V9H4.51v47.23h46.58v-20.2Z" />
    <path d="M55.6 23.99V7.79L36.37 27l-3.3-3.3L52.3 4.5H36.09V0H60.1v23.99h-4.5Z" />
  </svg>
</template>
